import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ProjectStateController } from '../../services/project-state.js';
import { router } from '../../services/router.js';
import type { Project } from '../../types/project.js';

@customElement('cp-project-tabs')
export class CpProjectTabs extends LitElement {
  createRenderRoot() { return this; }

  private _projectState = new ProjectStateController(this);

  private _onTabClick(project: Project): void {
    this._projectState.setActiveProject(project);
    router.navigateTo(`/projects/${project.id}`);
  }

  private _onTabClose(e: Event, project: Project): void {
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent('project-tab-close', {
      detail: { project },
      bubbles: true,
      composed: true,
    }));
  }

  private _onAddClick(): void {
    this.dispatchEvent(new CustomEvent('project-add-request', {
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    const projects = this._projectState.projects;
    const activeProject = this._projectState.activeProject;

    if (this._projectState.loadingState === 'loading' && projects.length === 0) {
      return html`
        <div class="cp-project-tabs">
          <div class="cp-project-tabs__loading">Lade Projekte...</div>
        </div>
      `;
    }

    return html`
      <div class="cp-project-tabs">
        <div class="cp-project-tabs__list">
          ${projects.map(project => html`
            <button
              class="cp-project-tabs__tab ${activeProject?.id === project.id ? 'cp-project-tabs__tab--active' : ''}"
              @click=${() => this._onTabClick(project)}
            >
              <span class="cp-project-tabs__tab-name">${project.name}</span>
              <span
                class="cp-project-tabs__tab-close"
                @click=${(e: Event) => this._onTabClose(e, project)}
                title="Tab schliessen"
              >&times;</span>
            </button>
          `)}
        </div>
        <button
          class="cp-project-tabs__add"
          @click=${this._onAddClick}
          title="Projekt hinzufuegen"
        >+</button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-project-tabs': CpProjectTabs;
  }
}
